import {Component} from '@angular/core';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';

@Component({
  selector: 'auto-shared-offer-set-rules-preview',
  templateUrl: './shared-offer-set-rules-preview.component.html',
  styleUrl: './shared-offer-set-rules-preview.component.scss'
})
export class SharedOfferSetRulesPreviewComponent {

  appliedFilters: any;
  isSave: boolean;
  searchValueOfferSets: string;
  searchValueTargetAccounts: string;
  targetAccounts = [];
  offerSets = [];

  constructor(
    private config: DynamicDialogConfig,
    public dialogRef: DynamicDialogRef
  ) {
    this.appliedFilters = this.config.data.appliedFilters;
    this.isSave = this.config.data.isSave;
  }

  /**
   * Method to display the names of the target accounts
   */
  get previewTableDataForTargetAccounts() {
    const rows = [];
    this.appliedFilters.targetAccountNames.forEach((targetAccountName) => {
      rows.push({
        targetAccount: targetAccountName
      });
    });
    return rows;
  }

  /**
   * Method to display the ames of the offer sets
   */
  get previewTableDataForOfferSets() {
    const rows = [];
    this.appliedFilters.offerSetNames.forEach((offerSetName) => {
      rows.push({
        offerSet: offerSetName
      });
    });
    return rows;
  }
}
